import { render, staticRenderFns } from "./final_question.vue?vue&type=template&id=3f8ca5e6"
import script from "./final_question.vue?vue&type=script&lang=js"
export * from "./final_question.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports